if (!customElements.get('read-more-toggle')) {
  customElements.define('read-more-toggle', class ReadMoreToggle extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.more = this.querySelector('.read-more__more');
      this.preview = this.querySelector('.read-more__preview');
      this.full = this.querySelector('.read-more__full');

      this.less = document.createElement('button');
      this.less.className = 'read-more__less';
      this.less.type = 'button';
      this.less.textContent = this.dataset.less;
      this.less.addEventListener('click', () => this.close());

      this.placeInline(this.preview, this.more);
      this.placeInline(this.full, this.less);

      this.more.addEventListener('click', () => this.open());
    }

    placeInline(container, button) {
      const target = container.querySelector('p:last-child') ?? container;
      target.append(' ', button);
    }

    open() {
      this.preview.hidden = true;
      this.full.removeAttribute('hidden');
      this.full.classList.add('is-animating');
    }

    close() {
      this.full.classList.remove('is-animating');
      this.full.hidden = true;
      this.preview.hidden = false;
    }
  });
}

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('read-more-toggle').forEach((el) => {
      el._initialized = false;
      el.connectedCallback();
    });
  });
}
